module.exports = __webpack_public_path__ + "img/hardyDrillShoulder1.ff3b7292.png";